import React from "react";

import useStyles from "../../hooks/useStyles";
import useTheme from "../../hooks/useTheme";
import { PlatformType } from "../../types/types";

export default function Exe(props: {
  store?: boolean;
  style?: React.CSSProperties;
}) {
  const theme = useTheme();

  return (
    <div
      style={{
        ...props.style,
      }}
    >
      <img
        src={theme.images.windows}
        style={useStyles.iconStore}
        alt={PlatformType.windows}
      />
    </div>
  );
}
